<div class="shiping-review">
  <div class="row">
    <div class="order-type">
      <div class="vs-text-field">
        <label
          ><span class="star"></span
          >{{ "orderCheckOut.shipmentMethod" | cxTranslate }}</label
        >
        <strong>{{ cartOrderReviewObj?.shipmentMethod }}</strong>
      </div>
    </div>
    <div class="order-type">
      <div class="vs-text-field">
        <label
          ><span class="star"></span
          >{{ "orderCheckOut.incoTermsLbl" | cxTranslate }}</label
        >
        <strong>{{ cartOrderReviewObj?.incoTermsCode }}</strong>
      </div>
    </div>
    <div class="order-type">
      <div class="vs-text-field">
        <label>{{ "orderCheckOut.freightTermsLbl" | cxTranslate }}</label>
        <strong>{{ cartOrderReviewObj?.freightTerm }}</strong>
      </div>
    </div>
    <div class="order-type">
      <div class="vs-text-field">
        <label
          ><span class="star"></span
          >{{ "orderCheckOut.freightAccountNumber" | cxTranslate }}</label
        >
        <strong class="wrap-fan">{{
          cartOrderReviewObj?.freightAccountNumber
        }}</strong>
      </div>
    </div>
    <div class="description">
      <label>{{ "orderCheckOut.shipingInstructions" | cxTranslate }}</label>
      <strong>{{ confirmShip }}</strong>
    </div>
    <div class="radio-content">
      <strong class="mt-3">
        {{ "orderCheckOut.specialInstLbl" | cxTranslate }}</strong
      >
      <div class="special-inst mt-4">
        <div
          class="instruction mb-2"
          *ngFor="let specialInstruction of specialInstructionData"
        >
          <label class="m-0">
            {{ specialInstruction?.code }}
          </label>
          <strong *ngIf="specialInstruction?.selected"
            >-{{ "orderCheckOut.yesLbl" | cxTranslate }}</strong
          >
          <strong *ngIf="!specialInstruction?.selected"
            >-{{ "orderCheckOut.none" | cxTranslate }}</strong
          >
        </div>
      </div>
      <div class="instruction mt-3 mb">
        <label for="others">
          {{ "orderCheckOut.othersDetails" | cxTranslate }}
        </label>
        <strong>{{ cartOrderReviewObj?.specialInstructionText }}</strong>
      </div>
    </div>
  </div>
</div>
